function Spain({ dimensions }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2188)">
  <path d="M0 15.9995C0 17.9566 0.352063 19.8313 0.995188 21.5647L16 22.956L31.0048 21.5647C31.6479 19.8313 32 17.9566 32 15.9995C32 14.0423 31.6479 12.1676 31.0048 10.4343L16 9.04297L0.995188 10.4343C0.352063 12.1676 0 14.0423 0 15.9995H0Z" fill="#FFDA44"/>
  <path d="M31.0049 10.4348C28.7442 4.34206 22.8795 0 16 0C9.12061 0 3.25593 4.34206 0.995239 10.4348H31.0049Z" fill="#D80027"/>
  <path d="M0.995239 21.5645C3.25593 27.6572 9.12061 31.9993 16 31.9993C22.8795 31.9993 28.7442 27.6572 31.0049 21.5645H0.995239Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Spain;
